module.exports = __webpack_public_path__ + "img/iconfolder.d6f39c0c.svg";